//per dags dato er det forskjellige løsninger i ulike SimCard-relaterte komponenter
//felles relevante funksjoner kan samles her

import { PredefinedColors } from "@phonero/pux-core"
import { Maybe } from "@phonero/common-graphql/types"

export type SimCardType = string | "SUBSCRIPTION" | "TWIN" | "DATACARD" | "EMBEDDED" | "" | undefined
export type SimCardStatus =
  | string
  | "ACTIVE"
  | "AVAILIBLE"
  | "DEACTIVE"
  | "ERROR"
  | "ACTIVATING"
  | "DEACTIVATING"
  | "ORDERED"
  | ""
  | undefined

/**
*Takes status of simcard @param {SimCardStatus} 
* 
*@returns {string}
*
*Available colours are:

*"primary" | "secondary" | "tertiary" | "success" | "warning" | "danger" | "light" | "medium" | "dark"
*/
export function getStateColour(status?: SimCardStatus | undefined): PredefinedColors {
  let colour: string = "primary" //default: #1442ac
  switch (status) {
    case "STARTACTIVATION":
      colour = "danger"
      break
    case "ACTIVE":
      colour = "success"
      break
    case "AVAILABLE":
      colour = "tertiary"
      break
    case "DEACTIVE":
      colour = "danger"
      break
    case "ACTIVATING":
      colour = "primary"
      break
    case "DEACTIVATING":
      colour = "success"
      break
    case "ORDERED":
      colour = "primary"
      break
    case "VALID":
      colour = "success"
      break
    case "INVALID":
      colour = "danger"
      break
    case "SEARCHING":
      colour = "primary"
      break
    case "NONE":
      colour = "medium"
      break
    case undefined || "":
      break
  }
  return colour as PredefinedColors
}

/**
 * Takes state of sim and activationdate: @param {string} @param {Maybe<Date> | Date | undefined}
 *
 * @returns {string}
 *
 * Helps determine which function to use depending on state of sim.
 *
 * Use this function when replacing uilib simcard (which has built-in handler for this) with puxsimcard.
 */
export function startActivateOrReplace(status: SimCardStatus, activationDate: Maybe<Date> | Date | undefined): string {
  const isActive = status === "ACTIVE" && activationDate
  const isReadyForActivation = status === "STARTACTIVATION" && !activationDate

  if (isReadyForActivation) {
    return "startActivation"
  }

  if (isActive) {
    return "replace"
  }

  return ""
}
